var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"index_pay"}},[(_vm.type===1)?_c('alipay',{attrs:{"data":_vm.data}}):_vm._e(),(_vm.type===2)?_c('qqWallet',{attrs:{"data":_vm.data}}):_vm._e(),(_vm.type===3)?_c('wechatpay',{attrs:{"data":_vm.data}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }